<template>
  <b-overlay :show="loading">
    <button
      type="button"
      class="button-secundary ml-2 mr-2 pl-3 pr-3"
      @click="$emit('click')"
    >
      <span class="cta">
        <slot></slot>
      </span>
    </button>
    <template #overlay>
      <overlay-button></overlay-button>
    </template>
  </b-overlay>
</template>
<script>
import overlayButton from "../overlay/overlay-button.vue";
export default {
  components: { overlayButton },
  name: "previus-edit-modal",
  props: {
    disabled: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["click"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
